module.exports = __webpack_public_path__ + "img/de-product-classify_img_7.9781ed12.jpg";